import * as React from "react";
import { Link } from "react-router-dom";

// Components
import Container from "../components/Container/Container";

// Misc.
import Topic from "../types/Topic.interface";
import FinishCard from "../components/FinishCard/FinishCard";

interface FinishPage {
  topics: Topic[];
}

const FinishPage: React.FC<FinishPage> = (props: FinishPage) => {
  const { topics } = props;

  return (
    <Container>
      <div className="w-11/12 xxl:w-full mx-auto">
        <h1 className="text-dw-blue text-xl sm:text-2xl md:text-3xl font-semibold font-serif mb-4">
          Download your policies and prepare them for your employees
        </h1>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {topics &&
            topics.map((topic) => <FinishCard key={topic._id} topic={topic} />)}
        </div>
        <div className="text-right">
          <Link
            className="block text-center bg-white text-dw-blue border border-dw-grey-06 px-4 py-2 text-s font-bold hover:bg-dw-blue hover:text-white mt-4 w-full sm:w-auto sm:ml-auto sm:inline-block"
            to="/categories"
          >
            Go back to overview
          </Link>
        </div>
      </div>
    </Container>
  );
};

export default FinishPage;
